import React, { createContext, useState } from "react";

const IntermediadorContext = createContext();

const IntermediadorContextProvider = ({ children }) => {
  const [intermediadorIdNew, setIntermediadorIdNew] = useState("");
  const [intermediadorCnpjNew, setIntermediadorCnpjNew] = useState("");
  const [intermediadorAtivoNew, setIntermediadorAtivoNew] = useState(true);
  const [isIntermediadorNew, setIsIntermediadorNew] = useState(true);
  const [intermediadorRazaoNew, setIntermediadorRazaoNew] = useState("");
  const [identificadorUsuarioNew, setIdentificadorUsuarioNew] = useState("");
  const [intermediadorDescricaoNew, setIntermediadorDescricaoNew] =
    useState("");
  const [tabelaPrecosIdNew, setTabelaPrecosIdNew] = useState(null);
  const [intermediadorTabelaPrecosId, setIntermediadorTabelaPrecosId] =
    useState("");
  const [tabelaPrecosData, setTabelaPrecosData] = useState([]);
  const [estoques, setEstoques] = useState(null);
  const [estoquesIdNew, setEstoquesIdNew] = useState([]);
  const [estoquesId, setEstoquesId] = useState([]);
  const [allIntermediaries, setAllIntermediaries] = useState([]);
  const [expanded, setExpanded] = useState({ general: true });
  const [geralErrors, setGeralErrors] = useState({});

  //Tela
  const [loading, setLoading] = useState(false);

  return (
    <IntermediadorContext.Provider
      value={{
        intermediadorIdNew,
        setIntermediadorIdNew,
        intermediadorCnpjNew,
        setIntermediadorCnpjNew,
        intermediadorAtivoNew,
        setIntermediadorAtivoNew,
        isIntermediadorNew,
        setIsIntermediadorNew,
        intermediadorRazaoNew,
        setIntermediadorRazaoNew,
        identificadorUsuarioNew,
        setIdentificadorUsuarioNew,
        intermediadorDescricaoNew,
        setIntermediadorDescricaoNew,
        tabelaPrecosIdNew,
        setTabelaPrecosIdNew,
        intermediadorTabelaPrecosId,
        setIntermediadorTabelaPrecosId,
        tabelaPrecosData,
        setTabelaPrecosData,
        estoques,
        setEstoques,
        estoquesIdNew,
        setEstoquesIdNew,
        estoquesId,
        setEstoquesId,
        allIntermediaries,
        setAllIntermediaries,
        expanded,
        setExpanded,
        loading,
        setLoading,
        geralErrors,
        setGeralErrors,
      }}
    >
      {children}
    </IntermediadorContext.Provider>
  );
};

export { IntermediadorContextProvider, IntermediadorContext };
